/* tslint:disable */
/* eslint-disable */
/**
 * FMS Run API
 * The FMS Run API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface ActivitySubmissionDetailsDto
 */
export interface ActivitySubmissionDetailsDto {
    /**
     * Unique identifier
     * @type {string}
     * @memberof ActivitySubmissionDetailsDto
     */
    'id': string;
    /**
     * Creation date in UTC
     * @type {string}
     * @memberof ActivitySubmissionDetailsDto
     */
    'createdAt': string;
    /**
     * Last update date in UTC
     * @type {string}
     * @memberof ActivitySubmissionDetailsDto
     */
    'updatedAt': string;
    /**
     * Last update date in UTC
     * @type {string}
     * @memberof ActivitySubmissionDetailsDto
     */
    'deletedAt': string;
    /**
     * Submission ID
     * @type {string}
     * @memberof ActivitySubmissionDetailsDto
     */
    'submissionId': string;
    /**
     * Submission approval status
     * @type {string}
     * @memberof ActivitySubmissionDetailsDto
     */
    'submissionStatus': ActivitySubmissionDetailsDtoSubmissionStatusEnum;
    /**
     * Reason for decline (only when status is declined)
     * @type {string}
     * @memberof ActivitySubmissionDetailsDto
     */
    'declineReason'?: string;
    /**
     * Challenge ID for easy reference
     * @type {string}
     * @memberof ActivitySubmissionDetailsDto
     */
    'submissionChallengeId'?: string;
    /**
     * Challenge name for easy reference
     * @type {string}
     * @memberof ActivitySubmissionDetailsDto
     */
    'submissionChallengeName'?: string;
    /**
     * Distance of the participation category in meters
     * @type {number}
     * @memberof ActivitySubmissionDetailsDto
     */
    'submissionCategoryDistance'?: number;
    /**
     * Distance added by this submission in meters (0 for pending/declined, activity distance for approved)
     * @type {number}
     * @memberof ActivitySubmissionDetailsDto
     */
    'submissionDistanceAdded'?: number;
    /**
     * Running distance covered at the time of submission in meters
     * @type {number}
     * @memberof ActivitySubmissionDetailsDto
     */
    'submissionRunningDistanceCovered'?: number;
    /**
     * Activity ID
     * @type {string}
     * @memberof ActivitySubmissionDetailsDto
     */
    'activityId': string;
    /**
     * Name of the activity
     * @type {string}
     * @memberof ActivitySubmissionDetailsDto
     */
    'activityName': string;
    /**
     * Description of the activity
     * @type {string}
     * @memberof ActivitySubmissionDetailsDto
     */
    'activityDescription'?: string;
    /**
     * Source of the activity
     * @type {string}
     * @memberof ActivitySubmissionDetailsDto
     */
    'activitySource': ActivitySubmissionDetailsDtoActivitySourceEnum;
    /**
     * Distance covered in meters
     * @type {number}
     * @memberof ActivitySubmissionDetailsDto
     */
    'activityDistance': number;
    /**
     * Duration of activity in seconds
     * @type {number}
     * @memberof ActivitySubmissionDetailsDto
     */
    'activityDuration': number;
    /**
     * Type of activity
     * @type {string}
     * @memberof ActivitySubmissionDetailsDto
     */
    'activityType': ActivitySubmissionDetailsDtoActivityTypeEnum;
    /**
     * Activity date in UTC
     * @type {string}
     * @memberof ActivitySubmissionDetailsDto
     */
    'activityDate': string;
    /**
     * Array of image URLs associated with this activity
     * @type {Array<string>}
     * @memberof ActivitySubmissionDetailsDto
     */
    'activityImageUrls'?: Array<string>;
    /**
     * Participation ID
     * @type {string}
     * @memberof ActivitySubmissionDetailsDto
     */
    'participationId': string;
    /**
     * Total distance covered in participation (meters)
     * @type {number}
     * @memberof ActivitySubmissionDetailsDto
     */
    'totalDistanceCovered': number;
    /**
     * Progress percentage for the participation
     * @type {number}
     * @memberof ActivitySubmissionDetailsDto
     */
    'progressPercentage': number;
    /**
     * Challenge ID
     * @type {string}
     * @memberof ActivitySubmissionDetailsDto
     */
    'challengeId'?: string;
    /**
     * Challenge title
     * @type {string}
     * @memberof ActivitySubmissionDetailsDto
     */
    'challengeTitle'?: string;
    /**
     * Challenge cover image URL
     * @type {string}
     * @memberof ActivitySubmissionDetailsDto
     */
    'challengeCoverImageUrl'?: string;
    /**
     * Challenge category distance in meters
     * @type {number}
     * @memberof ActivitySubmissionDetailsDto
     */
    'challengeCategoryDistance'?: number;
    /**
     * Challenge start date
     * @type {string}
     * @memberof ActivitySubmissionDetailsDto
     */
    'challengeStartsAt': string;
    /**
     * Challenge end date
     * @type {string}
     * @memberof ActivitySubmissionDetailsDto
     */
    'challengeEndsAt': string;
}

export const ActivitySubmissionDetailsDtoSubmissionStatusEnum = {
    Pending: 'pending',
    Approved: 'approved',
    Declined: 'declined'
} as const;

export type ActivitySubmissionDetailsDtoSubmissionStatusEnum = typeof ActivitySubmissionDetailsDtoSubmissionStatusEnum[keyof typeof ActivitySubmissionDetailsDtoSubmissionStatusEnum];
export const ActivitySubmissionDetailsDtoActivitySourceEnum = {
    Strava: 'strava',
    Garmin: 'garmin',
    Manual: 'manual',
    AppleHealth: 'apple_health'
} as const;

export type ActivitySubmissionDetailsDtoActivitySourceEnum = typeof ActivitySubmissionDetailsDtoActivitySourceEnum[keyof typeof ActivitySubmissionDetailsDtoActivitySourceEnum];
export const ActivitySubmissionDetailsDtoActivityTypeEnum = {
    Run: 'run',
    Bike: 'bike',
    Swim: 'swim'
} as const;

export type ActivitySubmissionDetailsDtoActivityTypeEnum = typeof ActivitySubmissionDetailsDtoActivityTypeEnum[keyof typeof ActivitySubmissionDetailsDtoActivityTypeEnum];


